<template>
	<div class="onboarding-text" :class="{ 'has-multiple-lines': numOfLines > 1 }">
		<AppTextArea v-model="onboardingText" :rows="maxRows" :auto-grow="hasAutoGrow" />
		<div class="limit-counter" v-if="onboardingText.length > 0">{{ onboardingText.length }} / {{ maxLength }}</div>
	</div>
</template>

<script>
export default {
	name: 'OnboardingTextPreview',
	props: {
		text: { type: String, default: '' },
		creatorName: { type: String, default: '' },
	},
	computed: {
		numOfLines() {
			const { onboardingTextNumLines, maxRows } = this;
			return onboardingTextNumLines > maxRows ? maxRows : onboardingTextNumLines;
		},
		onboardingTextNumLines() {
			return this.onboardingText.split('\n').length;
		},
		hasAutoGrow() {
			return this.onboardingTextNumLines < this.maxRows;
		},
		onboardingText: {
			get() {
				return this.text;
			},
			set(newV) {
				const oldV = this.text;
				const nextV = newV.length > this.maxLength ? oldV : newV;
				this.$nextTick(() => {
					this.$emit('onOnboardingTextUpdated', nextV);
				});
			},
		},
	},
	data() {
		return { isHideCreator: false, maxLength: 350, maxRows: 3 };
	},
};
</script>

<style scoped lang="scss">
.onboarding-text {
	position: relative;
	.limit-counter {
		position: absolute;
		bottom: 3px;
		right: 5px;
		color: var(--secondary-font-color);
	}

	::v-deep(.v-textarea) {
		border: 1px solid #e5e5e5;
		border-radius: 9px;
	}
	&:not(.has-multiple-lines) {
		::v-deep(.v-textarea) {
			padding: 4px 8px;
			border: 1px solid #e5e5e5;
			border-radius: 9px;

			.v-input__slot {
				padding: 0 !important;
			}
			.v-input__control {
				min-height: 30px;
			}
			textarea {
				line-height: 32px;
				padding: 0 !important;
				margin: 0 !important;
			}
		}
	}
}

.preview-onboarding-text {
	max-width: 350px;
	opacity: 0;
	transition: 0.2s;

	&.is-show {
		opacity: 1;
		transition: 0.7s;
	}
}
</style>
